/**
 * Avledet tekstmetadata for artikler — ordtelling og lesetid.
 *
 * Rene funksjoner uten I/O. Artikkelinnholdet er HTML fra AI-genereringen, så
 * tagger og entiteter må bort før det telles; ellers teller `<strong>` som ord.
 */

/** Norsk lesehastighet for sakprosa. 200 ord/min er den vanlige tommelfingerregelen. */
export const WORDS_PER_MINUTE = 200;

/** Ren tekst fra HTML — fjerner script/style, tagger og vanlige entiteter. */
export function htmlToPlainText(html: string): string {
  return String(html || '')
    .replace(/<(script|style)\b[^>]*>[\s\S]*?<\/\1>/gi, ' ')
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&[a-z]+;|&#\d+;/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

/** Antall ord i artikkelinnholdet. Tom/manglende HTML gir 0. */
export function wordCount(html: string): number {
  const text = htmlToPlainText(html);
  if (!text) return 0;
  return text.split(' ').filter(Boolean).length;
}

/**
 * Lesetid i hele minutter, alltid minst 1 for en artikkel som har innhold.
 * Returnerer 0 når det ikke finnes tekst — da skal ingenting vises.
 */
export function readingMinutes(html: string): number {
  const words = wordCount(html);
  if (words === 0) return 0;
  return Math.max(1, Math.round(words / WORDS_PER_MINUTE));
}

/** «5 min» / «1 240 ord» — norsk formatering med tusenskille. */
export function formatReadingTime(html: string): string {
  const m = readingMinutes(html);
  return m > 0 ? `${m} min` : '';
}

export function formatWordCount(html: string): string {
  const w = wordCount(html);
  return w > 0 ? `${w.toLocaleString('nb-NO')} ord` : '';
}
